import { ICodetableItem } from '../mgs.types';
import { IOption } from '@mng/mng-inputs';

export const CODETABLE_TYP_TIME4ME = 'PartnerTime4MeGruppe';
export const CODETABLE_TYP_PROGRAMMGRUPPE = 'ProgrammGruppe';
export const CODETABLE_TYP_LABORPROTOKOLLSTATUS = 'LaborProtokollStatus';
export const CODETABLE_TYP_KIDS_TERMIN_STATUS = 'KidsTerminStatus';
export const CODETABLE_TYP_KIDS_TERMIN_BEARBEITUNGS_STATUS = 'KidsTerminBearbeitungsStatus';
export const CODETABLE_TYP_KIDS_TERMIN_TYP = 'KidsTerminTyp';

export function codetableListToOptions(
  list: ICodetableItem[],
  withEmpty = false,
  valueType: 'id' | 'object' = 'id'
): IOption[] {
  const result = list.map(
    (codetableEntry) =>
      ({ name: codetableEntry.label, value: valueType === 'id' ? codetableEntry.id : codetableEntry }) as IOption
  );

  return withEmpty ? [{ name: '-', value: undefined }, ...result] : result;
}
